/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */
export { modelFromJSON } from './models';
//# sourceMappingURL=exports_models.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@tensorflow/tfjs-layers/dist/exports_models.js
// module id = 1623
// module chunks = 0